import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http/http-client.service';
import { environment } from '../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class RelacaoIndustriaService {

  constructor(private http: HttpService) { }

  industryRelationship(data: any, successHandle: Function, errorHandle: Function) {
    
    this.http.doGet('/enterprise/industryRelationship', data, successHandle, errorHandle);

  }
  
}

